import Ajax from '@/lib/ajax'

export default {
  // 获取列表
  getDataList(api: string, currentPage: number, pageSize: number, obj?: any) {
    let params = {
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize,
    }
    if(JSON.stringify(obj) != '{}') {
      params = {...params, ...obj}
    }
    return Ajax.get(api, {
      params,
    })
  },
}
